module.exports = __webpack_public_path__ + "img/idea-icon.61fd7263.svg";